import isEmpty from '@/helpers/isEmpty'
import { SelectionFilterField, SortFieldValue } from '../../types'

const searchInputKey = 'cbsi'

const sortFieldKey = 'cbs'
const filterFieldPrefix = 'cbf:'

const getFieldValueKey = (prefix: string, field: string) =>
  `${prefix}v-${field}`

const getFieldTextKey = (prefix: string, field: string) => `${prefix}t-${field}`
const getFieldSearchTextKey = (prefix: string, field: string) =>
  `${prefix}st-${field}`

const getControlBarDataFromUrl = ({
  filterFields,
}: {
  filterFields?: string[]
}) => {
  const filterFieldsMap = new Map<
    string,
    SelectionFilterField<string, string | string[]>
  >()

  const searchParams = new URLSearchParams(window.location.search.slice(1))

  filterFields?.forEach((field) => {
    const value = searchParams.getAll(
      getFieldValueKey(filterFieldPrefix, field)
    )
    const text = searchParams.get(getFieldTextKey(filterFieldPrefix, field))
    const searchText =
      searchParams.get(getFieldSearchTextKey(filterFieldPrefix, field)) ||
      undefined

    if (isEmpty(text)) {
      return
    }

    if (field.endsWith('[]')) {
      filterFieldsMap.set(field, {
        value: value.filter((v) => !isEmpty(v)),
        text,
        field,
        searchText,
      })
    } else {
      filterFieldsMap.set(field, {
        value: value[0],
        text,
        field,
        searchText,
      })
    }
  })

  return {
    filterFieldsMap,
    searchInputValue: searchParams.get(searchInputKey),
    sortFieldValue: searchParams.get(sortFieldKey),
  }
}

const setControlBarDataInUrl = ({
  filterFields,
  sortValue,
  searchInputValue,
}: {
  filterFields?: SelectionFilterField[]
  sortValue?: SortFieldValue
  searchInputValue?: string
}) => {
  if (
    !Array.isArray(filterFields) &&
    isEmpty(sortValue) &&
    typeof searchInputValue !== 'string'
  ) {
    return
  }

  const url = new URL(window.location.href)

  for (const key of Array.from(url.searchParams.keys())) {
    if (key.startsWith(filterFieldPrefix) && Array.isArray(filterFields)) {
      url.searchParams.delete(key)

      continue
    }

    if (key === sortFieldKey && sortValue === null) {
      url.searchParams.delete(key)

      continue
    }

    if (
      key === searchInputKey &&
      typeof searchInputValue === 'string' &&
      isEmpty(searchInputValue)
    ) {
      url.searchParams.delete(key)

      continue
    }
  }

  filterFields?.forEach(({ field, value, text, searchText }) => {
    if (isEmpty(text)) {
      return
    }

    if (Array.isArray(value)) {
      value.forEach((v) => {
        url.searchParams.append(
          getFieldValueKey(filterFieldPrefix, field),
          v.toString()
        )
      })
    } else if (
      typeof value === 'number' ||
      typeof value === 'string' ||
      typeof value === 'boolean'
    ) {
      url.searchParams.set(
        getFieldValueKey(filterFieldPrefix, field),
        value.toString()
      )
    }

    url.searchParams.set(getFieldTextKey(filterFieldPrefix, field), text)

    if (!isEmpty(searchText)) {
      url.searchParams.set(
        getFieldSearchTextKey(filterFieldPrefix, field),
        searchText
      )
    }
  })

  if (!isEmpty(sortValue)) {
    url.searchParams.set(sortFieldKey, sortValue.toString())
  }

  if (!isEmpty(searchInputValue)) {
    url.searchParams.set(searchInputKey, searchInputValue.trim())
  }

  window.history.replaceState(null, document.title, url.toString())
}

export { getControlBarDataFromUrl, setControlBarDataInUrl }
